import { Action, createReducer, on } from '@ngrx/store';

import * as AppActions from './app.actions';
import { AppSettings } from './app.models';

export const APP_FEATURE_KEY = 'app';

export interface AppState extends AppSettings {
  loaded: boolean; // has the App list been loaded
  error?: string | null; // last known error (if any)
  helpOpen: boolean;
}

export interface AppPartialState {
  readonly [APP_FEATURE_KEY]: AppState;
}

export const initialAppState: AppState = {
  loaded: false,
  helpOpen: false,
};

const reducer = createReducer(
  initialAppState,
  on(AppActions.initApp, (state) => ({ ...state, loaded: false, error: null })),
  on(AppActions.loadAppSuccess, (state, { app }) => ({
    ...app,
    loaded: true,
    helpOpen: state.helpOpen,
  })),
  on(AppActions.loadAppFailure, (state, { error }) => ({ ...state, error })),
  on(AppActions.toggleHelp, (state, { open }) => ({ ...state, helpOpen: open }))
);

export function appReducer(state: AppState | undefined, action: Action) {
  return reducer(state, action);
}
